<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-card title="Müşteri Bilgileri">
        <b-row>
          <b-col>
            <b-form-group>
              <label>Cari Tipi <span style="color:red">*</span></label>
              <b-form-radio-group v-model="client.type" :options="[
                { text: 'Bireysel', value: 'person' },
                { text: 'Kurumsal', value: 'business' },
              ]" stacked />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>{{ $t("Ad Soyad") }} <span style="color:red">*</span></label>
              <b-form-input v-model="client.full_name" :placeholder="$t('Ad Soyad')"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>{{ $t("Telefon Numarası") }}</label>
              <b-form-input v-model="client.gsm" v-mask="'+90 (###) ### ## ##'" :placeholder="$t('Telefon Numarası')"/>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>{{ $t("E - mail") }}</label>
              <b-form-input v-model="client.email" placeholder="E-mail"/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="3">
            <b-form-group>
              <label>{{ $t("Kategori") }} <span style="color:red">*</span></label>
              <b-form-select v-model="client.category_id" :options="categories" />
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" v-if="client.type=='business'">
            <b-form-group>
              <label>{{ $t("Ünvan") }} <span style="color:red">*</span></label>
              <b-form-input v-model="client.title" :placeholder="$t('Ünvan')"/>
            </b-form-group>
          </b-col>
          <b-col v-if="client.type === 'business'" sm="12" md="3">
            <b-row>
              <b-col>
                <b-form-group>
                  <label>{{ $t("Vergi Dairesi") }} <span style="color:red">*</span></label>
                  <b-form-input v-model="client.tax_office" :placeholder="$t('Vergi Dairesi')"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label>{{ $t("Vergi No") }} <span style="color:red">*</span></label>
                  <b-form-input v-model="client.tax_no" :placeholder="$t('Vergi No')"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-else sm="12" md="3">
            <b-form-group>
              <label>{{ $t("TC Kimlik No") }} <span style="color:red">*</span></label>
              <b-form-input v-model="client.identity_number" :placeholder="$t('TC Kimlik No')"/>
            </b-form-group>
          </b-col>
<!--          <b-col sm="12" md="3">-->
<!--            <b-form-group>-->
<!--              <label>Açılış Bakiyesi</label>-->
<!--              <b-form-input v-model="client.balance" placeholder="Açılış Bakiyesi"/>-->
<!--            </b-form-group>-->
<!--          </b-col>-->
          <b-col sm="12" md="3" v-if="client.type=='business'">
            <b-form-group >
              <label>{{ $t("Firma Adı") }} <span style="color:red">*</span></label>
              <b-form-input v-model="client.company_name" placeholder="Firma Adı"/>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-group>
              <label>{{ $t("İl") }}</label>
              <b-form-select v-model="client.city" :options="cityOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-group>
              <label>{{ $t("İlçe") }}</label>
              <b-form-select v-model="client.county" :options="countyOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="8">
            <b-form-group>
              <label>{{ $t("Adres") }}</label>
              <b-form-input v-model="client.address" placeholder="Adres"/>
            </b-form-group>
          </b-col>


        </b-row>

      </b-card>
      <hr>

      <b-card title="Banka Bilgileri">
        <div class="d-flex align-items-center" v-for="(account, key) in client.accounts" :key="key">
          <div style="width:100%">
            <b-row>
              <b-col sm="2">
                <b-form-group>
                  <label>{{ $t("Hesap Adı") }} <span style="color:red">*</span></label>
                  <b-form-input v-model="account.account_name" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>{{ $t("Banka Adı") }} <span style="color:red">*</span></label>
                  <b-form-input v-model="account.bank_name" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>{{ $t("Şube Adı") }}</label>
                  <b-form-input v-model="account.branch_name" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>{{ $t("Şube Kodu") }}</label>
                  <b-form-input v-model="account.branch_code" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>{{ $t("Hesap No") }} <span style="color:red">*</span></label>
                  <b-form-input v-model="account.account_number" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>{{ $t("Döviz") }} <span style="color:red">*</span></label>
                  <b-form-select v-model="account.currency" :options="[
                    { text: 'TL', value: 'TL' },
                    { text: 'USD', value: 'USD' },
                    { text: 'EUR', value: 'EUR' },
                  ]" />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group>
                  <label>{{ $t("IBAN") }} <span style="color:red">*</span></label>
                  <b-form-input v-model="account.iban" />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <hr>
              </b-col>
            </b-row>
          </div>
          <div class="text-center" style="width:70px;margin-left:20px;">
            <a href="#" @click.prevent="deleteBank(key)" class="btn btn-danger">Sil</a>
          </div>
        </div>

        <b-row>
          <b-col sm="12">
            <b-button variant="success" @click="addNewBank" block>+ {{ $t("Yeni Hesap Ekle") }}</b-button>
          </b-col>
        </b-row>
      </b-card>

      <div class="mt-3 text-right">
        <b-button variant="primary" class="loading-button" @click="save" :disabled="buttonLoading">
          <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t("Kaydet") }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    data() {
      return {
        buttonLoading: false,
        cities: [],
        client: {
          type: 'person',
          category_id: '',
          full_name: '',
          gsm: '',
          email: '',
          company_name: '',
          phone: '',
          website: '',
          city: '',
          county: '',
          address: '',
          tax_office: '',
          tax_no: '',
          accounts: [],
        },
        categories: [],
      }
    },
    computed: {
      cityOptions() {
        return this.cities ? Object.keys(this.cities) : [];
      },
      countyOptions() {
        return this.cities ? this.cities[this.client.city] : [];
      },
    },
    methods: {
      ...mapActions(['getClient', 'getCreateClient', 'createClient', 'updateClient']),
      deleteBank(key) {
        this.client.accounts.splice(key, 1);
        this.$forceUpdate();
      },
      addNewBank() {
        this.client.accounts.push({
          account_name: '',
          bank_name: '',
          branch_name: '',
          branch_code: '',
          account_number: '',
          currency: '',
          iban: '',
        });
        this.$forceUpdate();
      },
      save() {
        this.buttonLoading = true;
        if( this.client.id ) {
          // update
          this.updateClient({
          ...this.client,
          accounts: this.client.accounts,
        }).then(res => {
            this.success(res.data.message);
            this.buttonLoading = false;
            this.$router.push({name: 'clients'});
          }).catch(error => {
            this.error(error.response.data.message);
            this.buttonLoading = false;
          });
        } else {
          // create
          this.createClient({
          ...this.client,
          accounts: this.client.accounts,
        }).then(res => {
            this.success(res.data.message);
            this.buttonLoading = false;
            this.$router.push({name: 'clients'});
          }).catch(error => {
            this.error(error.response.data.message);
            this.buttonLoading = false;
          });
        }
      }
    },

    mounted() {
      if( this.$route.params.id ) {
        this.getClient(this.$route.params.id).then(response => {
          this.client = response.data.client;
          this.cities = response.data.cities;
          this.categories = response.data.categories;
          console.log(this.categories)
          this.client.accounts = response.data.accounts;
          this.$forceUpdate();
        });
      } else {
        this.getCreateClient().then(response => {
          this.cities = response.data.cities;
          this.categories = response.data.categories;
        });
      }
    }
  }
</script>